import { gql } from "../../../lib/Apollo"

export default gql`
  mutation($orderId: ID!) {
    payBookOrder(orderId: $orderId)
  }
`
